<div class="flex flex-col gap-4">
  <section>
    <h4 class="font-semibold mb-2">{{ 'animalAdd.securing.handover.headline' | transloco }}</h4>
    <div class="grid grid-cols-12 gap-3">
      <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.handover.authority' | transloco), value: origin.handoverAuthority?.name }" />
      <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.handover.responsibleContact' | transloco), value: responsibleContactName }" />
      <ng-container *ngTemplateOutlet="detail; context: { label: ('contacts.phoneLabel' | transloco), value: responsibleContactPhones }" />
      <ng-container *ngTemplateOutlet="detail; context: { label: ('contacts.email' | transloco), value: responsibleContact?.email }" />
      <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.handover.ownerPresent' | transloco), value: booleanLabel(origin.ownerPresentAtHandover) }" />
    </div>
  </section>

  <section>
    <h4 class="font-semibold mb-2">{{ 'animalAdd.securing.reasons.headline' | transloco }}</h4>
    <div class="grid grid-cols-12 gap-3">
      <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.reasons.label' | transloco), value: reasonLabels }" />
      <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.reasons.other' | transloco), value: origin.securingReasonOther }" />
    </div>
  </section>

  <section>
    <h4 class="font-semibold mb-2">{{ 'animalAdd.securing.incident.headline' | transloco }}</h4>
    <div class="grid grid-cols-12 gap-3">
      @if (origin.operationStartAt) {
        <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.incident.operationStartAt' | transloco), value: (origin.operationStartAt | date: 'dd.MM.yyyy HH:mm') }" />
      }
      @if (origin.operationEndAt) {
        <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.incident.operationEndAt' | transloco), value: (origin.operationEndAt | date: 'dd.MM.yyyy HH:mm') }" />
      }
      <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.incident.course' | transloco), value: origin.incidentCourse, wide: true }" />
      <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.incident.operationDescription' | transloco), value: origin.operationDescription, wide: true }" />
    </div>
  </section>

  @if (origin.biteVictimType || origin.biteVictimGender || origin.biteVictimAge != null) {
    <section>
      <h4 class="font-semibold mb-2">{{ 'animalAdd.securing.biteVictim.headline' | transloco }}</h4>
      <div class="grid grid-cols-12 gap-3">
        <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.biteVictim.type' | transloco), value: origin.biteVictimType ? biteVictimTypeLabel(origin.biteVictimType) : null }" />
        <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.biteVictim.gender' | transloco), value: origin.biteVictimGender ? biteVictimGenderLabel(origin.biteVictimGender) : null }" />
        <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.biteVictim.age' | transloco), value: origin.biteVictimAge }" />
      </div>
    </section>
  }

  <section>
    <h4 class="font-semibold mb-2">{{ 'animalAdd.securing.housing.headline' | transloco }}</h4>
    <div class="grid grid-cols-12 gap-3">
      <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.housing.conditions' | transloco), value: origin.housingConditionsDescription, wide: true }" />
      <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.housing.otherAnimalsLeftOnSite' | transloco), value: booleanLabel(origin.otherAnimalsLeftOnSite) }" />
      <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.housing.otherAnimalsDescription' | transloco), value: origin.otherAnimalsDescription, wide: true }" />
    </div>
  </section>

  <section>
    <h4 class="font-semibold mb-2">{{ 'animalAdd.securing.health.headline' | transloco }}</h4>
    <div class="grid grid-cols-12 gap-3">
      <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.health.status' | transloco), value: healthStatusLabels }" />
      <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.health.handedOverEquipment' | transloco), value: origin.handedOverEquipment }" />
      <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.health.needsImmediateVetCare' | transloco), value: booleanLabel(origin.needsImmediateVetCare) }" />
      <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.health.description' | transloco), value: origin.healthDescription, wide: true }" />
      <ng-container *ngTemplateOutlet="detail; context: { label: ('animalAdd.securing.health.behaviour' | transloco), value: origin.behaviourAtHandover, wide: true }" />
      <ng-container *ngTemplateOutlet="detail; context: { label: ('bcs.care.title' | transloco), value: careLabels }" />
      <ng-container *ngTemplateOutlet="detail; context: { label: ('bcs.nutrition.title' | transloco), value: nutritionValue }" />
      <ng-container *ngTemplateOutlet="detail; context: { label: ('bcs.temper.title' | transloco), value: temperamentLabels }" />
    </div>
  </section>

  @if (origin.presentShelterStaff && origin.presentShelterStaff.length > 0) {
    <section>
      <h4 class="font-semibold mb-2">{{ 'animalAdd.securing.signature.presentShelterStaff' | transloco }}</h4>
      @for (staff of origin.presentShelterStaff; track staff.id) {
        <p class="whitespace-pre-wrap">{{ staff.displayName || staff.name || staff.id }}</p>
      }
    </section>
  }
</div>

<ng-template #detail let-label="label" let-value="value" let-wide="wide">
  @if (value !== null && value !== undefined && value !== '') {
    <div [class]="wide ? 'col-span-12' : 'col-span-12 md:col-span-6'">
      <div class="text-sm text-gray-500">{{ label }}</div>
      <div class="whitespace-pre-wrap">{{ value }}</div>
    </div>
  }
</ng-template>
